
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import getContractorsMultiselectConditions from "@/helpers/getContractorsMultiselectConditions";

import InputRangeFilter from "@/components/filters/InputRangeFilterNew.vue";
import FiltersContainer from "@/components/filters/filters-container.vue";
import UiButton from "@/components/button/ui-button.vue";
import ContractorsMultiselect from "@/components/autocompleteMultiselects/ContractorsMultiselectNew.vue";
import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselectNew.vue";
import UIButton from "@/components/button/ui-button.vue";
import FormDatepicker from "../form/FormDatepickerV2.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelectNew.vue";
import UserCitiesMultiNew from "@/components/autocompleteMultiselects/UserLocationsMultiNew.vue";
import moment from "moment";
import Roles from "@/entities/Roles";
import ProjectsFiltersQuery from "@/entities/filters/ProjectsFiltersQuery";
import ProjectCityMultiselect from "@/components/autocompleteMultiselects/ProjectCityMultiselectNew.vue";
import RegionInput from "@/components/autocompleteMultiselects/RegionInputCustom.vue";
import UiButtonMessage from "@/components/button/ui-button-message.vue";

@Component({
  components: {
    RegionInput,
    UiButton,
    InputRangeFilter,
    FormDatepicker,
    FiltersContainer,
    ProjectCityMultiselect,
    ContractorsMultiselect,
    ManagersMultiselect,
    FormGroup,
    UIButton,
    UserCitiesMultiNew,
    ProfileCountrySelect,
    UiButtonMessage,
  },
})
export default class ProjectCollectionFilters extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly hideManagersFilter!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly hideContractorsFilter!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly hideBudgetFilter!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly hideCreatedDateFilter!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly hideAddressFilter!: boolean;
  @Prop({ type: String, default: undefined }) readonly currentUserId?: string;
  @Prop({ type: String, default: undefined })
  readonly currentUserRole?: string;
  @Prop({ type: Object, required: true })
  readonly filters!: ProjectsFiltersQuery;

  title: string = "";
  location: string = "";
  contractorsIds: string[] = [];
  managersIds: string[] = [];
  minBudget: string = "";
  maxBudget: string = "";
  createdAt: string = "";
  endDate: string = "";

  get propToWatch(): String {
    return JSON.stringify([
      this.title,
      this.minBudget,
      this.maxBudget,
      this.createdAt,
      this.endDate,
      this.contractorsIds,
      this.location,
      this.managersIds,
    ]);
  }

  get contractorsMultiselectConditions(): Object | undefined {
    return getContractorsMultiselectConditions(this.currentUserRole);
  }

  get managersMultiselectConditions(): Object | undefined {
    if (this.currentUserRole !== Roles.CONTRACTOR) {
      return {};
    }

    return {
      projects: {
        project_activities: {
          contractor: {
            user_id: {
              _eq: this.currentUserId,
            },
          },
        },
      },
    };
  }

  @Watch("filters", { immediate: true })
  updateFiltersValues(): void {
    this.title = this.filters.title;
    this.location = this.filters.location;
    this.contractorsIds = this.filters.contractors;
    this.managersIds = this.filters.managers;
    this.createdAt = this.filters.createdAt;
  }

  @Watch("propToWatch")
  handlePropToWatchChange(): void {
    const dateFormat = "YYYY-MM-DD";
    this.$emit("filtersChanged", {
      createdAt: this.createdAt
        ? moment.utc(this.createdAt).format(dateFormat)
        : "",
      title: this.title,
      minBudget: this.minBudget,
      maxBudget: this.maxBudget,
      contractors: this.contractorsIds,
      managers: this.managersIds,
      location: this.location,
    });
  }

  handleReset(): void {
    this.$emit("filtersReset");
  }
}
